module.exports = __webpack_public_path__ + "static/media/README.6cdf51a4.md";